// extracted by mini-css-extract-plugin
export var statItem = "_lc-1";
export var statsRow = "_lc-0";